import React from 'react';
import { FormattedMessage } from 'react-intl';
import Global from '../global-selectors';
import { PrintModalHelperService } from '../../services/print-modal-helper-service';
import { shipstationConnect } from '../../services/shipstation-connect';
import { DocumentService } from '../../services/document-service';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { PrinterIsUnavailable } from '../../pages/settings/connect/notifications/printer-is-unavailable';
import { messages } from './messages';

const getPrinterIsUnavailableTitle = ({ documentType }) => {
  const { documentNameTranslation } = DocumentService.getDocumentTypeEnumValueFromIdentifier(documentType) || {};
  const documentName = documentNameTranslation ? (
    <FormattedMessage {...documentNameTranslation} />
  ) : (
    <FormattedMessage {...messages.genericDocumentName} />
  );

  return <FormattedMessage {...messages.printingErrorTitle} values={{ documentName }} />;
};

export const showPrinterIsUnavailableNotification = ({ documentType, printer }) => {
  const notificationId = NotificationService.createNotificationId();
  NotificationService.showNotification({
    notificationId,
    notificationType: NOTIFICATION_TYPE_ERROR,
    dontHide: true,
    title: getPrinterIsUnavailableTitle({ documentType }),
    content: (
      <PrinterIsUnavailable notificationId={notificationId} selectedPrinterName={printer?.name} workstationId={printer?.workstationId} />
    ),
  });
};

export const getPrintSettingAndCheckIsOfflinePrinter = ({ state, printSettingKey }) => {
  // check that print setting is a printer
  const printSetting = Global.selectPrintSettingsByKey(state, {
    printSettingKey,
  });

  // if not a printer, accommodate the current expectations of the callers
  const isPrinter = !!printSetting?.workstationId;
  if (!isPrinter) {
    // TODO: DAT - eventually delete this method when the logic of the calling epics is ready for a rewrite.
    return {
      printSetting: PrintModalHelperService.determinePrinterForDocType(state, printSettingKey),
      isOfflinePrinter: false,
    };
  }

  const isPrinterAvailable = shipstationConnect.isPrinterAvailable(
    printSetting,
    Global.selectConnectFlattenedPrinters(state),
    Global.selectConnectWorkstations(state),
  );

  // if is available, then return printer
  if (isPrinterAvailable) {
    return { printSetting, isOfflinePrinter: false };
  }

  // show the user a notification and indicate to the callers that the printer is offline
  const { identifier } = DocumentService.getDocumentTypeEnumValueFromIdentifier(printSettingKey) || {};
  showPrinterIsUnavailableNotification({
    documentType: identifier,
    printer: printSetting,
  });
  return { printSetting, isOfflinePrinter: true };
};
